export enum FixedElements {
  header = 'header-append',
  footer = 'footer-wrapper',
}
